import { z } from 'zod';
/**
 * Booleanos que llegan como TEXTO: parámetros de una URL (`?includeChildren=false`)
 * y variables de entorno (`S3_SSE=false`).
 *
 * ☠️ NO usar `z.coerce.boolean()` para esto. Es `Boolean(valor)`, y en JavaScript
 * `Boolean('false')` y `Boolean('0')` son `true`: cualquier cadena no vacía lo es.
 * Así, desmarcar «Incluir subcuentas» en el Libro Mayor o «Ocultar ceros» en Sumas y
 * saldos no hacía nada (la pantalla seguía sumando las subcuentas y ocultando los
 * ceros mientras el PDF, que sí comparaba con 'false', hacía lo contrario: el 477
 * daba 1.155,00 € en pantalla y 105,00 € en el PDF). Y `S3_SSE=false` —que es lo que
 * documenta `infra/.env.example`— habría ACTIVADO el cifrado en reposo, que sin KMS
 * en MinIO rompe la subida de documentos.
 */
const VERDADEROS = new Set(['true', '1', 'yes', 'y', 'si', 'sí', 'on']);
const FALSOS = new Set(['false', '0', 'no', 'n', 'off']);
/**
 * Lee un booleano escrito como texto. Devuelve `undefined` si no lo reconoce, para
 * que quien llama decida (usar el valor por defecto o rechazar).
 */
export function parseBooleanText(value) {
    if (typeof value === 'boolean')
        return value;
    if (typeof value !== 'string')
        return undefined;
    const t = value.trim().toLowerCase();
    if (VERDADEROS.has(t))
        return true;
    if (FALSOS.has(t))
        return false;
    return undefined;
}
/**
 * Esquema de un booleano que puede venir como texto.
 *  - Ausente o vacío → `defaultValue` (una variable de entorno `X=` sin valor es «no definida»).
 *  - `true`/`false`/`1`/`0`/`yes`/`no`/`on`/`off` (en cualquier caso) → su valor.
 *  - Cualquier otra cosa → ERROR de validación: es preferible parar con un mensaje
 *    claro que adivinar y acabar con el valor contrario al querido.
 */
export function booleanFromText(defaultValue) {
    return z.preprocess((v) => {
        if (typeof v === 'string') {
            if (v.trim() === '')
                return undefined;
            const b = parseBooleanText(v);
            return b === undefined ? v : b;
        }
        return v;
    }, z.boolean().default(defaultValue));
}
//# sourceMappingURL=boolean-text.js.map